module.exports = __webpack_public_path__ + "img/Yekan.4c115c47.svg";